import Drawer from '@mui/material/Drawer';
import AudioPlayer from './AudioPlayer';
import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useRef } from 'react';

const AudioPlayerDrawer = ({ open, onClose, source, trackId, preservePlaybackOnClose = false }) => {
    const { state } = useLocation();
    const onCloseRef = useRef(onClose);
    const episodeRef = useRef(null);
    const onEpisodeLoaded = useCallback(episode => { episodeRef.current = episode; }, []);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    const closeAudioPlayer = useCallback((...args) => {
        const audio = document.getElementById('audio');
        const episode = episodeRef.current;
        const source = episode?.mp3URL && new URL(episode.mp3URL, document.baseURI).href;
        if (!preservePlaybackOnClose && episode?.id === trackId && source && audio?.src === source) audio.pause();
        onCloseRef.current?.(...args);
    }, [preservePlaybackOnClose, trackId]);

    useEffect(() => {
        if (state && !!state.closeAllModal) {
            closeAudioPlayer();
        }
    }, [closeAudioPlayer, state])

    // Continuing playback also needs the player's progress listeners after dismissal.
    return (
        <Drawer
            anchor='bottom' open={open} onClose={closeAudioPlayer}
            ModalProps={{ keepMounted: preservePlaybackOnClose }}>
            {trackId && <AudioPlayer key={trackId} close={closeAudioPlayer} source={source} trackId={trackId}
                onEpisodeLoaded={onEpisodeLoaded}
                preservePlaybackOnClose={preservePlaybackOnClose} />}
        </Drawer>
    );
};

export default AudioPlayerDrawer;
